var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"rows":_vm.rows,"fields":_vm.fields,"fixedHeight":_vm.fixedHeight,"invoice":""},scopedSlots:_vm._u([{key:"emptyTable",fn:function(){return [_c('EmptyTable')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }